import { Modal, ModalCancelButton, ModalCloseButton, ModalWidth } from '@dreryk/react-components';

import { appointmentsTranslationKeys } from '../../translations';

import { VisitReopenForm } from './VisitReopenForm';
import { VisitReopenModalConfirmButton } from './VisitReopenModalConfirmButton';

type VisitReopenModalProps = {
   readonly visitId: number;
   readonly onCancel: VoidFunction;
   readonly onSuccess: VoidFunction;
};

export const VisitReopenModal = (props: VisitReopenModalProps): JSX.Element => {
   return (
      <Modal
         testId={'reopenVisit'}
         title={appointmentsTranslationKeys.reopenVisitModal.title}
         width={ModalWidth.NORMAL}
      >
         <VisitReopenForm>
            {({ handleSubmit, formState }) => (
               <>
                  <VisitReopenModalConfirmButton
                     handleSubmit={handleSubmit}
                     visitId={props.visitId}
                     onSuccess={props.onSuccess}
                  />
                  <ModalCancelButton
                     onClick={props.onCancel}
                     shouldConfirmExit={{
                        enabled: formState.isDirty,
                        title: appointmentsTranslationKeys.reopenVisitModal.exitConfirmationModal.title,
                        confirmationButtonLabel:
                           appointmentsTranslationKeys.reopenVisitModal.exitConfirmationModal.confirm,
                        cancelButtonLabel: appointmentsTranslationKeys.reopenVisitModal.exitConfirmationModal.cancel,
                     }}
                  />
                  <ModalCloseButton onClick={props.onCancel} />
               </>
            )}
         </VisitReopenForm>
      </Modal>
   );
};
